import { addEventListenerWrap } from '@/utils/util'

export default function useScroll() {
  const scrollEvent = ref()
  const internalY = ref(0)

  const directions = reactive({
    top: false,
    bottom: false
  })

  const handleScroll = (e, callBack) => {
    const eventTarget = e.target === document ? e.target.documentElement : e.target
    const scrollTop = eventTarget.scrollTop
    directions.top = scrollTop < internalY.value
    directions.bottom = scrollTop > internalY.value
    internalY.value = scrollTop

    if (callBack) callBack(e)
  }

  const scrollTo = (top) => {
    document.querySelector('body').scrollTo({
      top
    })
  }

  const start = (callBack?: any) => {
    scrollEvent.value = addEventListenerWrap(
      document,
      'scroll',
      e => handleScroll(e, callBack)
    )
  }

  return {
    start,
    scrollTo,
    internalY,
    scrollEvent,
    directions
  }
}
